import { useNavigate } from 'react-router-dom'
import { Construction } from 'lucide-react'
import Button from '@/components/ui/Button'
import PageWrapper from '@/components/layout/PageWrapper'

/**
 * PlaceholderPage — temporary stand-in for pages not yet built.
 * Drop this as the element for any route during development so
 * the whole router still works and navigation can be tested.
 */
export default function PlaceholderPage({ pageName }) {
  const navigate = useNavigate()
  const name = pageName || document.title || 'This page'

  return (
    <PageWrapper showBack>
      <div className="flex flex-col items-center justify-center min-h-[60vh] gap-5 text-center px-4">
        <div className="w-16 h-16 bg-siglat-amber/10 border border-siglat-amber/20 rounded-xl flex items-center justify-center">
          <Construction className="w-7 h-7 text-siglat-amber" />
        </div>
        <div>
          <p className="font-display text-base font-bold text-ink-primary mb-1">
            Coming in Block {'{N}'}
          </p>
          <p className="text-sm text-ink-muted max-w-xs">
            <span className="text-ink-secondary font-medium">{name}</span> is
            queued for a future build session. Navigation and layout are wired.
          </p>
        </div>
        <Button variant="ghost" onClick={() => navigate(-1)}>
          Go back
        </Button>
      </div>
    </PageWrapper>
  )
}
